import React, { useState, useEffect, useLayoutEffect } from "react";

/** Components */
import {
  TableContainer,
  DialogTitle,
  Checkbox,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TablePagination,
  TableFooter,
  ButtonGroup,
  Collapse,
  Button,
  TextField,
  Dialog,
  DialogContent,
  DialogActions,
  Paper,
  Grid,
} from "@mui/material";
import ButtonWithAPICall from "../commons/ButtonWithAPICall.component";
import SelectStatusButton from "../commons/SelectStatusButton";
import LoadingProgress from "../../components/commons/LoadingProgress.component";
import { FilterBy } from "../commons/filter.component";

/** Package */
import { useTranslation } from "react-i18next";

/** API */
import { getCustomers, changeCustomersStatus, postSync, updateCustomer, getBanks, getBact } from "../../services/api";
import { setHeaderTitle } from "../../store/layoutSlide";

/** Icon  */
import RefreshIcon from "@mui/icons-material/Refresh";
import SearchIcon from "@mui/icons-material/Search";
import { useDispatch } from "react-redux";

// ghi đè prototype contains của string để kiểm tra xem string có chứa stringToCheck không
// eslint-disable-next-line no-extend-native
String.prototype.contains = function (stringToCheck) {
  if (!stringToCheck) return true;
  return this.normalize().toLowerCase().includes(stringToCheck.toString().normalize().toLowerCase());
};

const initialFilter = {
  id: "",
  customer: "",
};
const tblCustomerHeader = ["ID", "Khách hàng", "Tên viết tắt", "Mã số thuế", "Email-Hoá đơn", "Email-Thông báo thu tiền", "Địa chỉ đăng ký", "Trạng thái"];

const Customers = () => {
  //boiler plate
  const [t] = useTranslation();
  const dispatch = useDispatch();

  //table state
  const [data, setData] = useState();
  const [changeIds, setChangeIds] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [selectedRow, setSelectedRow] = useState(null);
  //filter
  const [filter, setFilter] = useState({ ...initialFilter });
  const [isOpen, setOpen] = useState(false);

  /** Set header title */

  useEffect(() => {
    dispatch(setHeaderTitle("THÔNG TIN KHÁCH HÀNG"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //on mount
  useEffect(() => {
    if (!data)
      getCustomers().then((res) => {
        res.code === 200 && setData(res.data);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //effect
  useEffect(() => {
    setPage(0);
  }, [filter]);

  //methods
  const handleSaveResponse = (res) => {
    if (res.code === 200) {
      setData((prev) => prev.map((item) => (item.id === res.data.id ? res.data : item)));
    }
  };
  const handleCheckBoxClick = (id) => {
    if (changeIds.includes(id)) setChangeIds((prev) => prev.filter((item) => item !== id));
    else setChangeIds((prev) => [...prev, id]);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleUpdateStatus = (selectedStatus) => {
    return changeCustomersStatus({ ids: changeIds, action: selectedStatus.action });
  };
  const handleUpdateStatusResponse = (res, selectedStatus) => {
    if (res.code === 200) {
      let newStatus;
      switch (selectedStatus.action) {
        case 0:
          newStatus = "DEACTIVATED";
          break;
        case 1:
          newStatus = "ACTIVATED";
          break;
        case 4:
          setChangeIds([]);
          newStatus = "DELETED";
          break;
        default:
          break;
      }
      setData((prev) => prev.map((item) => (changeIds.includes(item.id) ? { ...item, status: newStatus } : item)));
    }
  };

  // Main Render
  return (
    <div>
      <div align="right" style={{ marginTop: 5, marginBottom: 2, backgroundColor: "#b3deff", height: 40 }}>
        <ButtonGroup style={{ height: 40, marginRight: 5 }}>
          <ButtonWithAPICall title="Đồng bộ dữ liệu" api={() => postSync({ object: "customer" })} variant="outlined">
            <RefreshIcon />
          </ButtonWithAPICall>
          <Button onClick={() => setOpen((prev) => !prev)}>
            <SearchIcon />
          </Button>
        </ButtonGroup>
      </div>

      <Collapse in={isOpen} sx={{ marginBottom: 2 }}>
        <TextField sx={{ margin: 2 }} value={filter.id} onChange={(e) => setFilter((prev) => ({ ...prev, id: e.target.value }))} label="ID" />
        <TextField sx={{ margin: 2 }} value={filter.customer} onChange={(e) => setFilter((prev) => ({ ...prev, customer: e.target.value }))} label={t("Khách hàng")} />
      </Collapse>
      {!data ? (
        <LoadingProgress />
      ) : (
        <TableContainer component={Paper} style={{ width: "98%", marginLeft: 10 }} sx={{ maxHeight: 800 }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                {tblCustomerHeader.map((item, index) => (
                  <TableCell key={index} style={{ border: "0.5px solid lightgray" }}>
                    {t(item)}
                  </TableCell>
                ))}
                <TableCell style={{ border: "0.5px solid lightgray" }}>
                  <SelectStatusButton disabled={!changeIds.length} api={handleUpdateStatus} response={handleUpdateStatusResponse} />
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data
                .filter((item) => item.id.toString().contains(filter.id) && item.name.contains(filter.customer))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => (
                  <TableRow key={row.id} hover style={{ cursor: "pointer" }} onClick={(e) => e.target.type !== "checkbox" && setSelectedRow(row)}>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.id} </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray", minWidth: 150 }} align="left">
                      {row.name}
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.shortname}</TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.tax_code}</TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.email?.replaceAll(",", "\n")}</TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.ci_mails?.replaceAll(",", "\n")}</TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }} align="left">
                      {row.address}
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{t(row.status)}</TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>
                      <Checkbox disabled={row.status === "DELETED"} checked={changeIds.includes(row.id)} onClick={handleCheckBoxClick.bind(this, row.id)} />
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[10, 25, 100]}
                  count={data.filter((item) => item.id.toString().contains(filter.id) && item.name.contains(filter.customer)).length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      )}
      <EditCustomerDialog data={selectedRow} onClose={() => setSelectedRow(null)} onResponse={handleSaveResponse} />
    </div>
  );
};
const EditCustomerDialog = ({ data, onClose, onResponse }) => {
  const [t] = useTranslation();
  const [input, setInput] = useState({
    dft: "",
    fullname: "",
    rpl_ci: 0,
    bank: null,
    bact: null,
    ci_mails: "",
    prepaid: 0,
    ci_file: 0,
    IATA: "",
    ICAO: "",
    pp_mails: "data.pp_mails",
    pp_floor_limit: 0,
  });
  const handleSave = (e) => {
    return updateCustomer(data.id, {
      dft: input.dft,
      fullname: input.fullname,
      rpl_ci: input.rpl_ci,
      bank_id: input.bank?.id,
      bact_id: input.bact?.id,
      ci_mails: input.ci_mails,
      prepaid: input.prepaid,
      ci_file: input.ci_file,
      IATA: input.IATA,
      ICAO: input.ICAO,
      pp_mails: input.pp_mails,
      pp_floor_limit: input.pp_floor_limit,
    });
  };

  const onHandleCIMailsKeyDown = (evt) => {
    if (["Enter", "Tab"].includes(evt.key)) {
      evt.preventDefault();

      var email = input.ci_mails.split(",");
      const pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
      var new_ci_mails = "";
      if (email != null) {
        email.forEach((element) => {
          if (pattern.test(element.replaceAll(" ", ""))) new_ci_mails = new_ci_mails === "" ? element.replaceAll(" ", "") : new_ci_mails + "," + element.replaceAll(" ", "");
        });
      }
      setInput((prev) => ({ ...prev, ci_mails: new_ci_mails }));
    }
  };

  useLayoutEffect(() => {
    if (!data) return;
    setInput({
      dft: data.dft,
      fullname: data.fullname,
      rpl_ci: data.rpl_ci,
      bank_id: data.bank_id,
      bact_id: data.bact_id,
      ci_mails: data.ci_mails,
      prepaid: data.prepaid,
      ci_file: data.ci_file,
      IATA: data.IATA,
      ICAO: data.ICAO,
      pp_mails: data.pp_mails,
      pp_floor_limit: data.pp_floor_limit,
    });
  }, [data]);
  return (
    <Dialog open={Boolean(data)} onClose={onClose} maxWidth={"md"} fullWidth>
      <DialogTitle style={{ backgroundColor: "#0288D1", color: "white" }} align="center">
        {t("SỬA THÔNG TIN KHÁCH HÀNG")}
      </DialogTitle>
      <DialogContent style={{ paddingTop: 10 }}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <TextField disabled fullWidth label={t("Khách hàng")} value={data?.name || ""} style={{ margin: "5px 0" }} InputLabelProps={{ shrink: true }} />
            <TextField disabled fullWidth label={t("Mã số thuế")} value={data?.tax_code || ""} style={{ margin: "5px 0" }} InputLabelProps={{ shrink: true }} />
            <TextField
              InputLabelProps={{ shrink: true }}
              fullWidth
              label={t("Mã IATA")}
              value={input?.IATA || ""}
              style={{ margin: "5px 0" }}
              onChange={(e) => setInput((prev) => ({ ...prev, IATA: e.target.value }))}
            />
            <div style={{ display: "flex", alignItems: "center" }}>
              <Checkbox checked={Boolean(input.dft)} onChange={(e, value) => setInput((prev) => ({ ...prev, dft: value ? 1 : 0 }))} />
              Khách hàng là đại lý bán hàng
            </div>
            <TextField
              InputLabelProps={{ shrink: true }}
              fullWidth
              label={t("Tên đầy đủ")}
              value={input?.fullname || ""}
              style={{ margin: "5px 0" }}
              onChange={(e) => setInput((prev) => ({ ...prev, fullname: e.target.value }))}
            />
            <div style={{ display: "flex", alignItems: "center" }}>
              <Checkbox checked={Boolean(input.prepaid)} onChange={(e, value) => setInput((prev) => ({ ...prev, prepaid: value ? 1 : 0 }))} />
              Khách hàng trả trước
            </div>
            <TextField
              InputLabelProps={{ shrink: true }}
              disabled={!Boolean(input.prepaid)}
              fullWidth
              label={t("Email nhận cảnh báo hạn mức trả trước")}
              value={input?.pp_mails || ""}
              style={{ margin: "5px 0" }}
              multiline
              maxRows={4}
              onChange={(e) => setInput((prev) => ({ ...prev, pp_mails: e.target.value }))}
            />
            <TextField
              InputLabelProps={{ shrink: true }}
              disabled={!Boolean(input.prepaid)}
              fullWidth
              label={t("Hạn mức trả trước tối thiểu")}
              value={input?.pp_floor_limit || ""}
              style={{ margin: "5px 0" }}
              onChange={(e) => setInput((prev) => ({ ...prev, pp_floor_limit: e.target.value }))}
            />
          </Grid>
          <Grid item xs={6}>
            <div style={{ display: "grid", gridTemplateColumns: "1fr", gridGap: 10, marginTop: 5 }}>
              <FilterBy
                value={input.bank}
                onChange={(e, newvalue) => setInput((prev) => ({ ...prev, bank: newvalue, bank_id: newvalue.id }))}
                getDataFunc={() => getBanks({ status: 1 })}
                triggerSetDefaultFunc={data}
                setDefaultFunc={(option) => setInput((prev) => ({ ...prev, bank: option.find((item) => item.id === input.bank_id) || null }))}
                label={t("Ngân hàng")}
                getOptionLabel={(option) => `${option.id} - ${option.vi_name}`}
              />
              <FilterBy
                disabled={!input.bank}
                value={input.bact}
                onChange={(e, newvalue) => setInput((prev) => ({ ...prev, bact: newvalue, bact_id: newvalue.id }))}
                getDataFunc={() => getBact({ status: 1, bank_id: input.bank?.id })}
                triggerSetDefaultFunc={input.bank}
                setDefaultFunc={(option) => setInput((prev) => ({ ...prev, bact: option.find((item) => item.id === input.bact_id) || null }))}
                triggerGetDataFunc={input.bank}
                getDataDependencies={[input.bank]}
                label={t("Tài khoản ngân hàng")}
                getOptionLabel={(option) => `${option.act_number} - ${option.currency}`}
                // eslint-disable-next-line eqeqeq
                filter={(option) => option.status == "ACTIVATED"}
              />
              <TextField
                InputLabelProps={{ shrink: true }}
                fullWidth
                label={t("Mã ICAO")}
                value={input?.ICAO || ""}
                style={{ margin: "5px 0" }}
                onChange={(e) => setInput((prev) => ({ ...prev, ICAO: e.target.value }))}
              />
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <Checkbox checked={Boolean(input.rpl_ci)} onChange={(e, value) => setInput((prev) => ({ ...prev, rpl_ci: value ? 1 : 0 }))} />
              Sử dụng tên đầy đủ khi phát hành CI
            </div>
            <TextField
              InputLabelProps={{ shrink: true }}
              fullWidth
              label={t("Email nhận CI (sử dụng dấu , để ngăn cách các email)")}
              value={input?.ci_mails || ""}
              style={{ margin: "5px 0" }}
              multiline
              maxRows={4}
              onChange={(e) => setInput((prev) => ({ ...prev, ci_mails: e.target.value }))}
              onKeyDown={(e) => onHandleCIMailsKeyDown(e)}
            />
            <div style={{ display: "flex", alignItems: "center" }}>
              <Checkbox checked={Boolean(input.ci_file)} onChange={(e, value) => setInput((prev) => ({ ...prev, ci_file: value ? 1 : 0 }))} />
              Gửi kèm file tổng hợp (pdf) khi phát hành CI
            </div>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t("Hủy")}</Button>
        <ButtonWithAPICall variant="contained" api={handleSave} response={onResponse}>
          {t("Lưu")}
        </ButtonWithAPICall>
      </DialogActions>
    </Dialog>
  );
};
export default Customers;
